import './Dashboard.css';

interface SecondaryEmotionsProps {
  emotions: Record<string, number>;
  dominantEmotion: { emotion: string; intensity: number };
}

// Friendly labels for secondary emotions
const EMOTION_LABELS: Record<string, string> = {
  contentment: 'Contentment',
  excitement: 'Excitement',
  pride: 'Pride',
  gratitude: 'Gratitude',
  melancholy: 'Melancholy',
  disappointment: 'Disappointment',
  grief: 'Grief',
  homesickness: 'Homesickness',
  anxiety: 'Anxiety',
  worry: 'Worry',
  dread: 'Dread',
  vulnerability: 'Vulnerability',
  frustration: 'Frustration',
  indignation: 'Indignation',
  irritation: 'Irritation',
  affection: 'Affection',
  tenderness: 'Tenderness',
  protectiveness: 'Protectiveness',
  admiration: 'Admiration',
  wonder: 'Wonder',
  fascination: 'Fascination',
  intrigue: 'Intrigue',
  embarrassment: 'Embarrassment',
  guilt: 'Guilt',
  shame: 'Shame',
  empathy: 'Empathy',
  compassion: 'Compassion',
};

export function SecondaryEmotions({ emotions, dominantEmotion }: SecondaryEmotionsProps) {
  // Get top 6 emotions by intensity
  const sorted = Object.entries(emotions)
    .filter(([, v]) => v > 0.01)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 6);

  return (
    <div className="panel secondary-emotions-panel">
      <h3 className="panel-title">
        Emotional Texture
        {dominantEmotion.intensity > 0.1 && (
          <span className="dominant-badge">
            {EMOTION_LABELS[dominantEmotion.emotion] || dominantEmotion.emotion}
          </span>
        )}
      </h3>
      <div className="emotion-badges">
        {sorted.map(([emotion, intensity]) => (
          <div
            key={emotion}
            className={`emotion-badge ${emotion === dominantEmotion.emotion ? 'dominant' : ''}`}
            style={{ opacity: Math.max(0.4, intensity) }}
          >
            <span className="emotion-name">{EMOTION_LABELS[emotion] || emotion}</span>
            <span className="emotion-intensity">{(intensity * 100).toFixed(0)}%</span>
          </div>
        ))}
        {sorted.length === 0 && (
          <div className="emotion-badge empty">Neutral</div>
        )}
      </div>
    </div>
  );
}
